import CombinedForm from './CombinedForm';

export default CombinedForm;
